import {
  FinancialApplicationFormSectionSummary,
  FinancialApplicationFormSectionSummaryDataRow,
} from "../FinancialApplicationFormSectionSummary/FinancialApplicationFormSectionSummary";
import { useFieldSchemaToGetDataForPersonalAccountBeneficiarySummary } from "../FinancialApplicationFormSectionSummary/useFieldSchemaToGetDataForSummary";
import { FieldInput } from "@/utils/getFieldSchemaData";
import { COMPLEX_FIELD_KEYS, FIELD_KEYS } from "@/constants/fieldKeys";
import { usePersonalAccountBeneficiariesSummary } from "@/hooks/usePersonalAccountBeneficiariesSummary";
import { useMemo } from "react";
import { STEP_PATHS } from "@/config/stepPaths";

export interface PersonalAccountBeneficiariesSummaryV2Props {
  financialApplicationId: string;
}

export const PersonalAccountBeneficiariesSummaryV2: React.FC<
  PersonalAccountBeneficiariesSummaryV2Props
> = ({ financialApplicationId }) => {
  const { personalAccountBeneficiaries, isLoading } = usePersonalAccountBeneficiariesSummary(financialApplicationId);

  const summaryData = useMemo(() => {
    const data: FinancialApplicationFormSectionSummaryDataRow[] = [];

    const fieldsToInclude: FieldInput[] = [
      {
        fieldProps: FIELD_KEYS.PERSONAL_ACCOUNT_BENEFICIARY.RELATIONSHIP_TO_PRIMARY_OWNER,
      },
      {
        fieldProps: FIELD_KEYS.PERSONAL_ACCOUNT_BENEFICIARY.PERSON_INFORMATION,
        complexFieldValue: {
          hiddenFields: [
            COMPLEX_FIELD_KEYS.PERSON_INFORMATION.DATE_OF_BIRTH,
            COMPLEX_FIELD_KEYS.PERSON_INFORMATION.PHONE_NUMBER,
            COMPLEX_FIELD_KEYS.PERSON_INFORMATION.EMAIL_ADDRESS,
            COMPLEX_FIELD_KEYS.PERSON_INFORMATION.HOME_ADDRESS,
          ],
        },
      },
    ];

    // Process each personal account beneficiary
    personalAccountBeneficiaries.forEach((beneficiary) => {
      const beneficiarySummaryData = useFieldSchemaToGetDataForPersonalAccountBeneficiarySummary(
        beneficiary,
        fieldsToInclude
      );
      data.push(...beneficiarySummaryData);
    });

    return data;
  }, [personalAccountBeneficiaries]);

  if (isLoading) {
    return null; // Or a loading spinner if preferred
  }

  return (
    <FinancialApplicationFormSectionSummary
      title="Beneficiaries"
      data={summaryData}
      navigateTo={`/step/${STEP_PATHS.Beneficiaries}`}
    />
  );
};
